(() => {
  const init = () => document.querySelectorAll('[data-hero-slideshow]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const pause = root.querySelector('[data-slideshow-pause]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, stopped = false, visible = true;
    const show = next => {
      index = next;
      slides.forEach((slide,i) => { slide.classList.toggle('is-active',i === index); slide.setAttribute('aria-hidden',String(i !== index)); });
      dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === index)));
    };
    dots.forEach((dot,i) => dot.addEventListener('click',() => show(i)));
    pause.addEventListener('click',() => {
      stopped = !stopped;
      pause.setAttribute('aria-pressed',String(stopped));
      pause.setAttribute('aria-label',stopped ? 'Reanudar imágenes' : 'Pausar imágenes');
      pause.firstElementChild.textContent = stopped ? '▷' : 'Ⅱ';
    });
    const motion = () => { pause.hidden = reduced.matches; };
    reduced.addEventListener('change',motion); motion();
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });observer.observe(root);
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); observer.disconnect(); reduced.removeEventListener('change',motion); return; }
      if (!reduced.matches && !stopped && visible && !document.hidden && !root.querySelector(':focus-visible')) show((index+1)%slides.length);
    },6500);
  });
  init(); document.addEventListener('shopify:section:load',init);
})();
